/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown> }} Spellcheck_In_Progress_LabelInputs */

const en_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spell check in progress: ${i?.progress}%`)
};

const fr_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verification orthographique en cours : ${i?.progress}%`)
};

const de_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rechtschreibprüfung läuft: ${i?.progress}%`)
};

const it_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Controllo ortografico in corso: ${i?.progress}%`)
};

const ru_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Идет проверка орфографии: ${i?.progress}%`)
};

const es_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revisión ortográfica en curso: ${i?.progress}%`)
};

const zh_cn2_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`拼写检查进行中：${i?.progress}%`)
};

const ja_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`スペルチェック中: ${i?.progress}%`)
};

const hi_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वर्तनी जाँच जारी है: ${i?.progress}%`)
};

const pt_pt2_spellcheck_in_progress_label = /** @type {(inputs: Spellcheck_In_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verificação ortográfica em andamento: ${i?.progress}%`)
};

/**
* | output |
* | --- |
* | "Spell check in progress: {progress}%" |
*
* @param {Spellcheck_In_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_in_progress_label = /** @type {((inputs: Spellcheck_In_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_In_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_in_progress_label(inputs)
	if (locale === "de") return de_spellcheck_in_progress_label(inputs)
	if (locale === "it") return it_spellcheck_in_progress_label(inputs)
	if (locale === "ru") return ru_spellcheck_in_progress_label(inputs)
	if (locale === "es") return es_spellcheck_in_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_in_progress_label(inputs)
	if (locale === "ja") return ja_spellcheck_in_progress_label(inputs)
	if (locale === "hi") return hi_spellcheck_in_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_in_progress_label(inputs)
	return en_spellcheck_in_progress_label(inputs)
});